<template>
  <div class="form-group chat-wrapper">
    <div class="comment-form" ref="commentForm">
      <div class="d-flex flex-wrap align-items-center position-relative">
        <input type="text" name="msg" class="form-control" placeholder="Message" v-model="message.text" />
        <div class="btn-actions">
          <ButtonUpload :config="{ multiple: true }" v-model="message.attachments" :focus="focus" class="add-images">
            <template v-slot:beforeUploadButton="object">
              <label :for="`upload-file-${object.uid}`">
                <i class="icon icon-attachment"></i>
              </label>
            </template>
          </ButtonUpload>
          <i class="icon icon-send" @click="sendMessage"></i>
        </div>
        <ThumbnailPreview v-model="message.attachments" class="image-thumbnail mt-2"></ThumbnailPreview>
      </div>
    </div>
    <div class="chat-wrapper">
      <ul class="chat-inner">
        <li class="chat-box-container topic">
          <div class="w-100 position-relative">
            <div class="chat-box-wrapper">
              <div class="chat-box-inner">
                <p class="user-message" v-html="topic"></p>
              </div>
            </div>
          </div>
        </li>
        <li v-for="(object, index) in data" :key="index" :class="`chat-box-container ${object.type || ''}`">
          <div class="w-100 position-relative">
            <div class="chat-box-wrapper">
              <div class="chat-box-inner">
                <p class="user-wrapper">
                  <span class="user-name">{{ object.user_name }}</span>
                  <span class="user-role">{{ object.user_role }}</span>
                </p>
                <p class="date-created-wrapper" v-html="$util.timestampToDateTime(object.date_created)"></p>
                <p class="user-message" v-html="handleMessage(object.message)"></p>
              </div>
              <ThumbnailPreview :value="object.attachments" readonly class="attachment-thumbnail">
                <template v-slot:before-wrapper="imageProps">
                  <div class="mask" @click="fullScreenPreview(imageProps)"></div>
                </template>
              </ThumbnailPreview>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ButtonUpload from '@/components/ButtonUpload.vue'
import ThumbnailPreview from '@/components/ThumbnailPreview.vue'
export default {
  components: {
    ButtonUpload,
    ThumbnailPreview
  },
  data() {
    return {
      focus: false,
      data: [],
      message: {
        text: '',
        attachments: []
      }
    }
  },
  created() {
    this.data = this.messages
  },
  computed: {
    manufactureId() {
      return this.config?.id
    },
    messages() {
      return Object.values(this.config?.messages || [])
    },
    topic() {
      return this.config?.topic || ''
    }
  },
  methods: {
    handleMessage(text) {
      return this.$util.autoLink((text || '').replace(/\n/g, '<br>'))
    },
    fullScreenPreview(e) {
      this.$emitter.emit('SubModal', {
        name: 'full-screen-image-preview',
        data: {
          files: this.$util.reduce(
            e.images,
            ({ next, item }) => {
              return Object.values(next).concat(Object.values(item.items || item.files || item.urls))
            },
            []
          ),
          thumbnail: true,
          index: e.index
        }
      })
    },
    sendMessage() {
      let data = {
        message: this.message.text,
        attachments: this.message.attachments
      }
      this.$util.post(`manufacture/message/create/${this.manufactureId}`, data, this.$refs.commentForm).then((response) => {
        if (response.status == 'success') {
          this.data.unshift(response.data)
          this.message = {
            text: '',
            attachments: []
          }
        }
      })
    }
  },
  props: {
    config: Object
  },
  watch: {
    messages(values) {
      this.data = values
    }
  }
}
</script>

<style lang="scss">
.edit-manufacture-form {
  .chat-wrapper {
    .chat-inner {
      list-style: none;
      padding: 0;
      margin-top: 15px;
      > :last-child {
        margin-bottom: 0;
      }
    }
    .chat-box-container {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 15px;
      &.cause {
        .user-wrapper {
          display: none;
        }
        .chat-box-inner {
          background-color: #ffeabc;
        }
      }
      .chat-box-wrapper {
        display: block;
        padding: 0;
        word-break: break-word;
      }
      .chat-box-inner {
        background-color: #f0f2f5;
        border-radius: 18px;
        padding: 8px 15px;
      }
      .user-name {
        font-weight: bold;
        font-size: 13px;
      }

      .user-role,
      .date-created {
        font-size: 12px;
        color: #aaa;
        font-style: italic;
        margin-left: 5px;
      }
      .date-created-wrapper {
        font-size: 11px;
        color: #aaa;
      }
      p {
        margin: 0;
      }
      .message-imgs {
        display: flex;
        flex-wrap: wrap;
        img {
          border-radius: 10px;
          border: 1px solid #dfdfdf;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-top: 5px;
          margin-right: 5px;
        }
      }
      small {
        font-size: 12px;
        color: #65676b;
        a {
          color: inherit;
          text-decoration: none;
          font-weight: bold;
          padding-right: 5px;
        }
      }
    }
  }
}
</style>
